export default "__VITE_ASSET__b753b826__"